<script lang="ts" setup>
  import { ChatBubbleLeftEllipsisIcon } from '@heroicons/vue/24/solid'
  import { type ResolvedActivity, useGeneratedEmployeeAvatarStore } from '@/stores'

  const props = defineProps<{
    activityItem: ResolvedActivity
  }>()
  const { activity } = props.activityItem
  const { origin } = props.activityItem

  const employeeAvatarStore = useGeneratedEmployeeAvatarStore()
  // const employeeStore = useGeneratedEmployeeStore()
  const originAvatar = origin?.id ? await employeeAvatarStore.fetchByEmployee({ path: { employee: origin.id.toString() } }) : undefined
  let originAvatarUrl: string | undefined = undefined
  if (originAvatar) {
    originAvatarUrl = originAvatar.avatars?.widget_profile_avatar
  }
  // let originName = "System";
  // if(activityItem.value.origin){
  //   originName=(await employeeStore.fetch(activity.value.origin))?.displayname ?? "System"
  // }
</script>

<template>
  <div class="relative flex items-start space-x-3">
    <div class="relative">
      <img
        v-if="originAvatarUrl"
        :src="originAvatarUrl"
        alt=""
        class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-400 ring-8 ring-white" />
      <div
        v-else
        class="h-10 w-10" />
      <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
        <ChatBubbleLeftEllipsisIcon
          aria-hidden="true"
          class="h-5 w-5 text-gray-400" />
      </span>
    </div>
    <div class="min-w-0 flex-1">
      <div>
        <div class="text-sm">
          {{ origin?.displayname }}
          <!--                        <a :href="activityItem.person.href" class="font-medium text-gray-900">{{-->
          <!--                          activityItem.person.name-->
          <!--                        }}</a>-->
        </div>
        <p class="mt-0.5 text-sm text-gray-500">Commented {{ $formatter.DateTime(activity.createdAt!) }}</p>
      </div>
      <div class="mt-2 text-sm text-gray-700">
        <p>{{ activity.data }}</p>
      </div>
    </div>
  </div>
</template>
